export default "__VITE_ASSET__8ff6fa0b__"